import { createSelector } from 'reselect';

const getIsSubmitting = createSelector(
  (state) => state.feedback.isSubmitting,
  (isSubmitting) => isSubmitting
);

const getHasLoaded = createSelector(
  (state) => state.feedback.hasLoaded,
  (hasLoaded) => hasLoaded
);

const getFeedbackData = createSelector(
  (state) => state.feedback.data,
  (data = {}) => data
);

const getMotivationalAudioUrl = createSelector(
  (state) => state.feedback.motivationalAudioUrl,
  (motivationalAudioUrl) => motivationalAudioUrl
);

export default {
  getFeedbackData,
  getHasLoaded,
  getIsSubmitting,
  getMotivationalAudioUrl,
};
